import { ThemeProvider, Typography, Link, Box } from "@mui/material"
import { theme } from "@ikhokha/commons-ui"
import { extractAndValidatePlatform } from "../utils/auth.util"

export default function Information({ message }: { message?: string }) {
	const email = "support@ikhokha.com"
	const subject = ""
	const body = ""
	const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`

	const platform = extractAndValidatePlatform(window.location.search)

	const isIKFlyerClient: boolean = platform === "iKFlyer"
	const phoneNumber = "087 222 7000"

	const preventDefault = (event) => event.preventDefault()

	return (
		<ThemeProvider theme={theme}>
			<Box sx={{ display: "flex", flexDirection: "column", color: "#8B8B87",alignItems:"center" }}>
				<Typography variant="caption">
					Need help? Call{" "}
					{isIKFlyerClient ? (
						<Link href="#" onClick={preventDefault}>
							{phoneNumber}
						</Link>
					) : (
						<Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
					)}{" "}
					or
				</Typography>
				<Typography variant="caption">
					email{" "}
					{isIKFlyerClient ? (
						<Link href="#" onClick={preventDefault}>
							{message || "onboarding@ikhokha.com"}
						</Link>
					) : (
						<Link href={mailtoLink}> {message || "onboarding@ikhokha.com"}</Link>
					)}
				</Typography>
			</Box>
		</ThemeProvider>
	)
}
